import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withTermsOfUseText, WithTermsOfUseTextProps } from '@/components/termsOfUse/withTermsOfUseText';

interface TermsOfUseContentComponentProps extends WithTermsOfUseTextProps {}

export const TermsOfUseContentComponent: React.FC<TermsOfUseContentComponentProps> = ({ text }) => {
  return <HelpTextMarkdown id={'terms-of-use'} text={text} />;
};

export const TermsOfUseContent = withTermsOfUseText(TermsOfUseContentComponent);
